import { render } from "./MovimentoFinanceiroTitulosBaixados.vue?vue&type=template&id=5f8fa929&ts=true"
import script from "./MovimentoFinanceiroTitulosBaixados.vue?vue&type=script&lang=ts"
export * from "./MovimentoFinanceiroTitulosBaixados.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__